import { createNamespacedHelpers } from 'vuex'

const { mapActions: mapDashboardActions, mapGetters: mapDashboardGetters, mapState: mapDashboardState } = createNamespacedHelpers('dashboard')
const { mapGetters: mapToolsGetters, mapState: mapToolsState } = createNamespacedHelpers('tools')

const DashboardMixin = {
  data() {
    return {
      isFormValid: true,
    }
  },
  computed: {
    ...mapDashboardState({
      $confirmCancelDashboard: (state) => state.confirmCancelDashboard,
      $deleteIndexDashboard: (state) => state.deleteIndexDashboard,
      $deleteLabelDashboard: (state) => state.deleteLabelDashboard,
      $denyDeleteDashboard: (state) => state.denyDeleteDashboard,
      $formDashboard: (state) => state.formDashboard,
      $isModalVisibleDashboard: (state) => state.isModalVisibleDashboard,
      $promptDeleteDashboard: (state) => state.promptDeleteDashboard,
    }),
    ...mapDashboardGetters([
      'dashboards',
      'emptyDashboardCard',
    ]),
    ...mapToolsGetters([
      'currentNav',
      'routeMap',
      'selectedSearch',
    ]),
    ...mapToolsState({
      associationId: (state) => state.associationId,
      baseReportName: (state) => state.baseReportName,
      reportPath: (state) => state.reportPath,
      routeName: (state) => state.routeName,
      subId: (state) => state.subId,
    }),

    reportCode() {
      return `${this.associationId}/${this.subId}`
    },

    confirmCancelDashboard: {
      get() {
        return this.$confirmCancelDashboard
      },
      set(value) {
        this.$store.commit('dashboard/confirmCancelDashboard', value)
      },
    },
    promptDeleteDashboard: {
      get() {
        return this.$promptDeleteDashboard
      },
      set(value) {
        this.$store.commit('dashboard/promptDeleteDashboard', value)
      },
    },
    deleteIndexDashboard: {
      get() {
        return this.$deleteIndexDashboard
      },
      set(value) {
        this.$store.commit('dashboard/deleteIndexDashboard', value)
      },
    },
    deleteLabelDashboard: {
      get() {
        return this.$deleteLabelDashboard
      },
      set(value) {
        this.$store.commit('dashboard/deleteLabelDashboard', value)
      },
    },
    denyDeleteDashboard: {
      get() {
        return this.$denyDeleteDashboard
      },
      set(value) {
        this.$store.commit('dashboard/denyDeleteDashboard', value)
      },
    },
    formDashboard: {
      get() {
        return this.$formDashboard
      },
      set(value) {
        this.$store.commit('dashboard/formDashboard', value)
      },
    },
    isModalVisibleDashboard: {
      get() {
        return this.$isModalVisibleDashboard
      },
      set(newValue) {
        this.$store.commit('dashboard/isModalVisibleDashboard', newValue)
      },
    },
  },
  watch: {
    dashboards: {
      deep: true,
      handler() {},
      immediate: true,
    },
    selectedSearch: {
      deep: true,
      handler() {},
      immediate: true,
    },
  },
  methods: {
    ...mapDashboardActions([
      'createDashboard',
      'deleteDashboard',
      'updateDashboard',
      'submitFormDashboard',
    ]),

    createDashboardAndResetForm() {
      const { formDashboard, reportCode } = this
      const { action, entry } = formDashboard

      if (action === 'create' && Array.isArray(entry)) {
        this.createDashboard(reportCode)
      } else {
        this.isFormValid = false
      }
    },
    deleteDashboardAndResetForm(indexToDelete) {
      const { reportCode } = this
      this.deleteDashboard({ indexToDelete, reportCode })
      this.promptDeleteDashboard = false
    },

    cancelDeleteDashboard() {
      this.denyDeleteDashboard = false
      this.promptDeleteDashboard = false
    },
    confirmDeleteDashboard(dashboard) {
      this.deleteIndexDashboard = dashboard.index
      this.deleteLabelDashboard = dashboard.reportLabel
      this.promptDeleteDashboard = true
    },
  },
}

export default DashboardMixin
